import { useMemo } from 'react';

import {
  useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery,
  useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery,
} from '../graphql/__generated__';

export function useSalesCoverageUnderwriterEmployeeDetailQuery(
  employeeKey: string,
  tenantId?: string
) {
  const customerResponse = useCrmManagement_SalesCoverage_UnderwriterEmployeeDetailQuery({
    variables: { employeeKey },
    skip: !employeeKey || !!tenantId,
  });

  const adminResponse = useCrmManagement_SalesCoverage_AdminUnderwriterEmployeeDetailQuery({
    variables: { employeeKey, tenantId: tenantId ?? '' },
    skip: !employeeKey || !tenantId,
  });

  const employee = useMemo(() => {
    return (
      customerResponse.data?.underwriterEmployees?.items?.[0] ??
      adminResponse.data?.adminUnderwriterEmployees?.items?.[0] ??
      null
    );
  }, [customerResponse.data, adminResponse.data]);

  return {
    employee,
    loading: customerResponse.loading || adminResponse.loading,
    error: customerResponse.error || adminResponse.error,
  };
}
